import { ApiClient } from 'api/RestClient';
import { StatsItRVO } from 'types/it/main/StatsItRVO';
import { doFetch } from 'util/AxiosUtil';

export const findStatsIt = async () => {
  return doFetch<StatsItRVO>(ApiClient, `/api/stats/it`).then((res) => res.data.response);
};
